<template>
  <div>
    <div><h4>Overview</h4></div>
    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-12 overview">
        <div class="card">
          <div class="card-body">
            <div class="card-title">
              <v-row>
                <v-col cols="3" class="title"> Job</v-col>
                <v-col cols="9" class="row" style="text-align: right">
                  <div class="col-sm-6 col-lg-6">
                    <label for="start-date"> From </label>
                    <input
                      type="date"
                      name="start-date"
                      class="date-picker"
                      v-model="start_date_job"
                      :max="end_date_job"
                      @change="getRequestJobStatistics()"
                    />
                  </div>
                  <div class="col-sm-6 col-lg-6">
                    <label for="end-date"> To </label>
                    <input
                      type="date"
                      name="end-date"
                      class="date-picker"
                      v-model="end_date_job"
                      :max="max_date"
                      :min="start_date_job"
                      @change="getRequestJobStatistics()"
                    />
                  </div>
                </v-col>
              </v-row>
            </div>
            <div class="card-content">
              <v-row
                class="item"
                v-for="item in lst_job_request"
                :key="item.type"
              >
                <label class="request-name"> {{ item.type }} </label>
                <progress
                  class="progress"
                  :value="item.number"
                  :max="total_job"
                ></progress>
                <label class="quantity"> {{ item.number }} </label>
                <label>
                  ({{
                    total_job != 0
                      ? Math.round((item.number * 100) / total_job)
                      : 0
                  }}%)
                </label>
              </v-row>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div><h4>Request Helper</h4></div>
    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-12">
        <div class="card">
          <div class="card-body">
            <div class="card-title">
              <v-row>
                <v-col cols="3" class="title"> Helper schedule</v-col>
                <v-col cols="9" class="row" style="text-align: right">
                  <div class="col-md-12 col-lg-6">
                    <label for="start-date"> From </label>
                    <input
                      type="date"
                      name="start-date"
                      class="date-picker"
                      v-model="start_date_work_schedule"
                      :max="end_date_work_schedule"
                      @change="getRequestScheduleStatistics()"
                    />
                  </div>
                  <div class="col-md-12 col-lg-6">
                    <label for="end-date"> To </label>
                    <input
                      type="date"
                      name="end-date"
                      class="date-picker"
                      v-model="end_date_work_schedule"
                      :max="max_date"
                      :min="start_date_work_schedule"
                      @change="getRequestScheduleStatistics()"
                    />
                  </div>
                </v-col>
              </v-row>
            </div>
            <div class="card-content">
              <v-row
                class="item"
                v-for="item in lst_work_schedule"
                :key="item.type"
              >
                <label class="request-name"> {{ item.type }} </label>
                <progress
                  class="progress"
                  :value="item.number"
                  :max="total_schedule"
                ></progress>
                <label class="quantity"> {{ item.number }} </label>
                <label>
                  ({{
                    total_schedule != 0
                      ? Math.round((item.number * 100) / total_schedule)
                      : 0
                  }}%)
                </label>
              </v-row>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-6 col-md-6 col-sm-12">
        <div class="card">
          <div class="card-body">
            <div class="card-title">
              <v-row>
                <v-col cols="3" class="title"> Helper Language</v-col>
                <v-col cols="9" class="row" style="text-align: right">
                  <div class="col-md-12 col-lg-6">
                    <label for="start-date"> From </label>
                    <input
                      type="date"
                      name="start-date"
                      class="date-picker"
                      v-model="start_date_work_language"
                      :max="end_date_work_language"
                      @change="getRequestLanguageStatistics()"
                    />
                  </div>
                  <div class="col-sm-12 col-md-12 col-lg-6">
                    <label for="end-date"> To </label>
                    <input
                      type="date"
                      name="end-date"
                      class="date-picker"
                      v-model="end_date_work_language"
                      :max="max_date"
                      :min="start_date_work_language"
                      @change="getRequestLanguageStatistics()"
                    />
                  </div>
                </v-col>
              </v-row>
            </div>
            <div class="card-content">
              <v-row
                class="item"
                v-for="item in lst_work_language"
                :key="item.type"
              >
                <label class="request-name"> {{ item.type }} </label>
                <progress
                  class="progress"
                  :value="item.number"
                  :max="total_language"
                ></progress>
                <label class="quantity"> {{ item.number }} </label>
                <label>
                  ({{
                    total_language != 0
                      ? Math.round((item.number * 100) / total_language)
                      : 0
                  }}%)
                </label>
              </v-row>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12">
        <div class="card">
          <div class="card-body">
            <div class="card-title">
              <v-row>
                <v-col cols="3" class="title"> Helper national</v-col>
                <v-col cols="9" class="row" style="text-align: right">
                  <div class="col-md-12 col-lg-6">
                    <label for="start-date"> From </label>
                    <input
                      type="date"
                      name="start-date"
                      class="date-picker"
                      v-model="start_date_work_national"
                      :max="end_date_work_national"
                      @change="getRequestNationalStatistics()"
                    />
                  </div>
                  <div class="col-sm-12 col-md-12 col-lg-6">
                    <label for="end-date"> To </label>
                    <input
                      type="date"
                      name="end-date"
                      class="date-picker"
                      v-model="end_date_work_national"
                      :max="max_date"
                      :min="start_date_work_national"
                      @change="getRequestNationalStatistics()"
                    />
                  </div>
                </v-col>
              </v-row>
            </div>
            <div class="card-content">
              <v-row
                class="item"
                v-for="item in lst_work_national"
                :key="item.type"
              >
                <label class="request-name"> {{ item.type }} </label>
                <progress
                  class="progress"
                  :value="item.number"
                  :max="total_national"
                ></progress>
                <label class="quantity"> {{ item.number }} </label>
                <label>
                  ({{
                    total_national != 0
                      ? Math.round((item.number * 100) / total_national)
                      : 0
                  }}%)
                </label>
              </v-row>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12">
        <div class="card">
          <div class="card-body">
            <div class="card-title">
              <v-row>
                <v-col cols="3" class="title"> Helper Day</v-col>
                <v-col cols="9" class="row" style="text-align: right">
                  <div class="col-md-12 col-lg-6">
                    <label for="start-date"> From </label>
                    <input
                      type="date"
                      name="start-date"
                      class="date-picker"
                      v-model="start_date_work_day"
                      :max="end_date_work_day"
                      @change="getRequestDayStatistics()"
                    />
                  </div>
                  <div class="col-sm-12 col-md-12 col-lg-6">
                    <label for="end-date"> To </label>
                    <input
                      type="date"
                      name="end-date"
                      class="date-picker"
                      v-model="end_date_work_day"
                      :max="max_date"
                      :min="start_date_work_day"
                      @change="getRequestDayStatistics()"
                    />
                  </div>
                </v-col>
              </v-row>
            </div>
            <div class="card-content">
              <v-row class="item" v-for="item in lst_work_day" :key="item.type">
                <label class="request-name"> {{ item.type }} </label>
                <progress
                  class="progress"
                  :value="item.number"
                  :max="total_day"
                ></progress>
                <label class="quantity"> {{ item.number }} </label>
                <label>
                  ({{
                    total_day != 0
                      ? Math.round((item.number * 100) / total_day)
                      : 0
                  }}%)
                </label>
              </v-row>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-6 col-md-6 col-sm-12">
        <div class="card">
          <div class="card-body">
            <div class="card-title">
              <v-row>
                <v-col cols="3" class="title"> Helper cooking</v-col>
                <v-col cols="9" class="row" style="text-align: right">
                  <div class="col-md-12 col-lg-6">
                    <label for="start-date"> From </label>
                    <input
                      type="date"
                      name="start-date"
                      class="date-picker"
                      v-model="start_date_work_cooking"
                      :max="end_date_work_cooking"
                      @change="getRequestCookingStatistics()"
                    />
                  </div>
                  <div class="col-md-12 col-lg-6">
                    <label for="end-date"> To </label>
                    <input
                      type="date"
                      name="end-date"
                      class="date-picker"
                      v-model="end_date_work_cooking"
                      :max="max_date"
                      :min="start_date_work_cooking"
                      @change="getRequestCookingStatistics()"
                    />
                  </div>
                </v-col>
              </v-row>
            </div>
            <div class="card-content">
              <v-row
                class="item"
                v-for="item in lst_work_cooking"
                :key="item.type"
              >
                <label class="request-name"> {{ item.type }} </label>
                <progress
                  class="progress"
                  :value="item.number"
                  :max="total_cooking"
                ></progress>
                <label class="quantity"> {{ item.number }} </label>
                <label>
                  ({{
                    total_cooking != 0
                      ? Math.round((item.number * 100) / total_cooking)
                      : 0
                  }}%)
                </label>
              </v-row>
            </div>
          </div>
        </div>
      </div>

        <div class="col-lg-6 col-md-6 col-sm-12">
        <div class="card">
          <div class="card-body">
            <div class="card-title">
              <v-row>
                <v-col cols="3" class="title">Having Kid</v-col>
                <v-col cols="9" class="row" style="text-align: right">
                  <div class="col-md-12 col-lg-6">
                    <label for="start-date"> From </label>
                    <input
                      type="date"
                      name="start-date"
                      class="date-picker"
                      v-model="start_date_work_kid"
                      :max="end_date_work_kid"
                      @change="getRequestKidStatistics()"
                    />
                  </div>
                  <div class="col-md-12 col-lg-6">
                    <label for="end-date"> To </label>
                    <input
                      type="date"
                      name="end-date"
                      class="date-picker"
                      v-model="end_date_work_kid"
                      :max="max_date"
                      :min="start_date_work_kid"
                      @change="getRequestKidStatistics()"
                    />
                  </div>
                </v-col>
              </v-row>
            </div>
            <div class="card-content">
              <v-row
                class="item"
                v-for="item in lst_work_kid"
                :key="item.type"
              >
                <label class="request-name"> {{ item.type }} </label>
                <progress
                  class="progress"
                  :value="item.number"
                  :max="total_kid"
                ></progress>
                <label class="quantity"> {{ item.number }} </label>
                <label>
                  ({{
                    total_kid != 0
                      ? Math.round((item.number * 100) / total_kid)
                      : 0
                  }}%)
                </label>
              </v-row>
            </div>
          </div>
        </div>
      </div>

        <div class="col-lg-6 col-md-6 col-sm-12">
        <div class="card">
          <div class="card-body">
            <div class="card-title">
              <v-row>
                <v-col cols="3" class="title"> Having Pet</v-col>
                <v-col cols="9" class="row" style="text-align: right">
                  <div class="col-md-12 col-lg-6">
                    <label for="start-date"> From </label>
                    <input
                      type="date"
                      name="start-date"
                      class="date-picker"
                      v-model="start_date_work_pet"
                      :max="end_date_work_pet"
                      @change="getRequestPetStatistics()"
                    />
                  </div>
                  <div class="col-md-12 col-lg-6">
                    <label for="end-date"> To </label>
                    <input
                      type="date"
                      name="end-date"
                      class="date-picker"
                      v-model="end_date_work_pet"
                      :max="max_date"
                      :min="start_date_work_pet"
                      @change="getRequestPetStatistics()"
                    />
                  </div>
                </v-col>
              </v-row>
            </div>
            <div class="card-content">
              <v-row
                class="item"
                v-for="item in lst_work_pet"
                :key="item.type"
              >
                <label class="request-name"> {{ item.type }} </label>
                <progress
                  class="progress"
                  :value="item.number"
                  :max="total_pet"
                ></progress>
                <label class="quantity"> {{ item.number }} </label>
                <label>
                  ({{
                    total_pet != 0
                      ? Math.round((item.number * 100) / total_pet)
                      : 0
                  }}%)
                </label>
              </v-row>
            </div>
          </div>
        </div>
      </div>

        <div class="col-lg-6 col-md-6 col-sm-12">
        <div class="card">
          <div class="card-body">
            <div class="card-title">
              <v-row>
                <v-col cols="3" class="title"> Current Helper</v-col>
                <v-col cols="9" class="row" style="text-align: right">
                  <div class="col-md-12 col-lg-6">
                    <label for="start-date"> From </label>
                    <input
                      type="date"
                      name="start-date"
                      class="date-picker"
                      v-model="start_date_work_current_helper"
                      :max="end_date_work_current_helper"
                      @change="getRequestCurrentHelperStatistics()"
                    />
                  </div>
                  <div class="col-md-12 col-lg-6">
                    <label for="end-date"> To </label>
                    <input
                      type="date"
                      name="end-date"
                      class="date-picker"
                      v-model="end_date_work_current_helper"
                      :max="max_date"
                      :min="start_date_work_current_helper"
                      @change="getRequestCurrentHelperStatistics()"
                    />
                  </div>
                </v-col>
              </v-row>
            </div>
            <div class="card-content">
              <v-row
                class="item"
                v-for="item in lst_work_current_helper"
                :key="item.type"
              >
                <label class="request-name"> {{ item.type }} </label>
                <progress
                  class="progress"
                  :value="item.number"
                  :max="total_current_helper"
                ></progress>
                <label class="quantity"> {{ item.number }} </label>
                <label>
                  ({{
                    total_current_helper != 0
                      ? Math.round((item.number * 100) / total_current_helper)
                      : 0
                  }}%)
                </label>
              </v-row>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <h4>Request Driver</h4>
      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="card">
            <div class="card-body">
              <div class="card-title">
                <v-row>
                  <v-col cols="3" class="title"> Driver Salary</v-col>
                  <v-col cols="9" class="row" style="text-align: right">
                    <div class="col-md-12 col-lg-6">
                      <label for="start-date"> From </label>
                      <input
                        type="date"
                        name="start-date"
                        class="date-picker"
                        v-model="start_date_driver_salary"
                        :max="end_date_driver_salary"
                        @change="getRequestDriverSalaryStatistics()"
                      />
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-6">
                      <label for="end-date"> To </label>
                      <input
                        type="date"
                        name="end-date"
                        class="date-picker"
                        v-model="end_date_driver_salary"
                        :max="max_date"
                        :min="start_date_driver_salary"
                        @change="getRequestDriverSalaryStatistics()"
                      />
                    </div>
                  </v-col>
                </v-row>
              </div>
              <div class="card-content">
                <v-row
                  class="item"
                  v-for="item in lst_driver_salary"
                  :key="item.type"
                >
                  <label class="request-name"> {{ item.type }} </label>
                  <progress
                    class="progress"
                    :value="item.number"
                    :max="total_driver_salary"
                  ></progress>
                  <label class="quantity"> {{ item.number }} </label>
                  <label>
                    ({{
                      total_driver_salary != 0
                        ? Math.round((item.number * 100) / total_driver_salary)
                        : 0
                    }}%)
                  </label>
                </v-row>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="card">
            <div class="card-body">
              <div class="card-title">
                <v-row>
                  <v-col cols="3" class="title"> Driver Age</v-col>
                  <v-col cols="9" class="row" style="text-align: right">
                    <div class="col-md-12 col-lg-6">
                      <label for="start-date"> From </label>
                      <input
                        type="date"
                        name="start-date"
                        class="date-picker"
                        v-model="start_date_driver_age"
                        :max="end_date_driver_age"
                        @change="getRequestDriverAgeStatistics()"
                      />
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-6">
                      <label for="end-date"> To </label>
                      <input
                        type="date"
                        name="end-date"
                        class="date-picker"
                        v-model="end_date_driver_age"
                        :max="max_date"
                        :min="start_date_driver_age"
                        @change="getRequestDriverAgeStatistics()"
                      />
                    </div>
                  </v-col>
                </v-row>
              </div>
              <div class="card-content">
                <v-row
                  class="item"
                  v-for="item in lst_driver_age"
                  :key="item.type"
                >
                  <label class="request-name"> {{ item.type }} </label>
                  <progress
                    class="progress"
                    :value="item.number"
                    :max="total_driver_age"
                  ></progress>
                  <label class="quantity"> {{ item.number }} </label>
                  <label>
                    ({{
                      total_driver_age != 0
                        ? Math.round((item.number * 100) / total_driver_age)
                        : 0
                    }}%)
                  </label>
                </v-row>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="card">
            <div class="card-body">
              <div class="card-title">
                <v-row>
                  <v-col cols="3" class="title"> Driver Schedule</v-col>
                  <v-col cols="9" class="row" style="text-align: right">
                    <div class="col-md-12 col-lg-6">
                      <label for="start-date"> From </label>
                      <input
                        type="date"
                        name="start-date"
                        class="date-picker"
                        v-model="start_date_driver_schedule"
                        :max="end_date_driver_schedule"
                        @change="getRequestDriverScheduleStatistics()"
                      />
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-6">
                      <label for="end-date"> To </label>
                      <input
                        type="date"
                        name="end-date"
                        class="date-picker"
                        v-model="end_date_driver_schedule"
                        :max="max_date"
                        :min="start_date_driver_schedule"
                        @change="getRequestDriverScheduleStatistics()"
                      />
                    </div>
                  </v-col>
                </v-row>
              </div>
              <div class="card-content">
                <v-row
                  class="item"
                  v-for="item in lst_driver_schedule"
                  :key="item.type"
                >
                  <label class="request-name"> {{ item.type }} </label>
                  <progress
                    class="progress"
                    :value="item.number"
                    :max="total_driver_schedule"
                  ></progress>
                  <label class="quantity"> {{ item.number }} </label>
                  <label>
                    ({{
                      total_driver_schedule != 0
                        ? Math.round(
                            (item.number * 100) / total_driver_schedule
                          )
                        : 0
                    }}%)
                  </label>
                </v-row>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="card">
            <div class="card-body">
              <div class="card-title">
                <v-row>
                  <v-col cols="3" class="title"> Replacement Gurantee</v-col>
                  <v-col cols="9" class="row" style="text-align: right">
                    <div class="col-md-12 col-lg-6">
                      <label for="start-date"> From </label>
                      <input
                        type="date"
                        name="start-date"
                        class="date-picker"
                        v-model="start_date_driver_replacement_gurantee"
                        :max="end_date_driver_replacement_gurantee"
                        @change="
                          getRequestDriverReplacementGuranteeStatistics()
                        "
                      />
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-6">
                      <label for="end-date"> To </label>
                      <input
                        type="date"
                        name="end-date"
                        class="date-picker"
                        v-model="end_date_driver_replacement_gurantee"
                        :max="max_date"
                        :min="start_date_driver_replacement_gurantee"
                        @change="
                          getRequestDriverReplacementGuranteeStatistics()
                        "
                      />
                    </div>
                  </v-col>
                </v-row>
              </div>
              <div class="card-content">
                <v-row
                  class="item"
                  v-for="item in lst_driver_replacement_gurantee"
                  :key="item.type"
                >
                  <label class="request-name"> {{ item.type }} </label>
                  <progress
                    class="progress"
                    :value="item.number"
                    :max="total_driver_replacement_gurantee"
                  ></progress>
                  <label class="quantity"> {{ item.number }} </label>
                  <label>
                    ({{
                      total_driver_replacement_gurantee != 0
                        ? Math.round(
                            (item.number * 100) /
                              total_driver_replacement_gurantee
                          )
                        : 0
                    }}%)
                  </label>
                </v-row>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="card">
            <div class="card-body">
              <div class="card-title">
                <v-row>
                  <v-col cols="3" class="title"> Driver Interview</v-col>
                  <v-col cols="9" class="row" style="text-align: right">
                    <div class="col-md-12 col-lg-6">
                      <label for="start-date"> From </label>
                      <input
                        type="date"
                        name="start-date"
                        class="date-picker"
                        v-model="start_date_driver_interview"
                        :max="end_date_driver_interview"
                        @change="getRequestDriverInterviewStatistics()"
                      />
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-6">
                      <label for="end-date"> To </label>
                      <input
                        type="date"
                        name="end-date"
                        class="date-picker"
                        v-model="end_date_driver_interview"
                        :max="max_date"
                        :min="start_date_driver_interview"
                        @change="getRequestDriverInterviewStatistics()"
                      />
                    </div>
                  </v-col>
                </v-row>
              </div>
              <div class="card-content">
                <v-row
                  class="item"
                  v-for="item in lst_driver_interview"
                  :key="item.type"
                >
                  <label class="request-name"> {{ item.type }} </label>
                  <progress
                    class="progress"
                    :value="item.number"
                    :max="total_driver_interview"
                  ></progress>
                  <label class="quantity"> {{ item.number }} </label>
                  <label>
                    ({{
                      total_driver_interview != 0
                        ? Math.round(
                            (item.number * 100) / total_driver_interview
                          )
                        : 0
                    }}%)
                  </label>
                </v-row>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="card">
            <div class="card-body">
              <div class="card-title">
                <v-row>
                  <v-col cols="3" class="title"> Start Hiring</v-col>
                  <v-col cols="9" class="row" style="text-align: right">
                    <div class="col-md-12 col-lg-6">
                      <label for="start-date"> From </label>
                      <input
                        type="date"
                        name="start-date"
                        class="date-picker"
                        v-model="start_date_driver_hiring"
                        :max="end_date_driver_hiring"
                        @change="getRequestDriverHiringStatistics()"
                      />
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-6">
                      <label for="end-date"> To </label>
                      <input
                        type="date"
                        name="end-date"
                        class="date-picker"
                        v-model="end_date_driver_hiring"
                        :max="max_date"
                        :min="start_date_driver_hiring"
                        @change="getRequestDriverHiringStatistics()"
                      />
                    </div>
                  </v-col>
                </v-row>
              </div>
              <div class="card-content">
                <v-row
                  class="item"
                  v-for="item in lst_driver_hiring"
                  :key="item.type"
                >
                  <label class="request-name"> {{ item.type }} </label>
                  <progress
                    class="progress"
                    :value="item.number"
                    :max="total_driver_hiring"
                  ></progress>
                  <label class="quantity"> {{ item.number }} </label>
                  <label>
                    ({{
                      total_driver_hiring != 0
                        ? Math.round((item.number * 100) / total_driver_hiring)
                        : 0
                    }}%)
                  </label>
                </v-row>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="card">
            <div class="card-body">
              <div class="card-title">
                <v-row>
                  <v-col cols="3" class="title"> Driver Language</v-col>
                  <v-col cols="9" class="row" style="text-align: right">
                    <div class="col-md-12 col-lg-6">
                      <label for="start-date"> From </label>
                      <input
                        type="date"
                        name="start-date"
                        class="date-picker"
                        v-model="start_date_driver_language"
                        :max="end_date_driver_language"
                        @change="getRequestDriverLanguageStatistics()"
                      />
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-6">
                      <label for="end-date"> To </label>
                      <input
                        type="date"
                        name="end-date"
                        class="date-picker"
                        v-model="end_date_driver_language"
                        :max="max_date"
                        :min="start_date_driver_language"
                        @change="getRequestDriverLanguageStatistics()"
                      />
                    </div>
                  </v-col>
                </v-row>
              </div>
              <div class="card-content">
                <v-row
                  class="item"
                  v-for="item in lst_driver_language"
                  :key="item.type"
                >
                  <label class="request-name"> {{ item.type }} </label>
                  <progress
                    class="progress"
                    :value="item.number"
                    :max="total_driver_language"
                  ></progress>
                  <label class="quantity"> {{ item.number }} </label>
                  <label>
                    ({{
                      total_driver_language != 0
                        ? Math.round(
                            (item.number * 100) / total_driver_language
                          )
                        : 0
                    }}%)
                  </label>
                </v-row>
              </div>
            </div>
          </div>
        </div>

         <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="card">
            <div class="card-body">
              <div class="card-title">
                <v-row>
                  <v-col cols="3" class="title"> Own Car</v-col>
                  <v-col cols="9" class="row" style="text-align: right">
                    <div class="col-md-12 col-lg-6">
                      <label for="start-date"> From </label>
                      <input
                        type="date"
                        name="start-date"
                        class="date-picker"
                        v-model="start_date_driver_owncar"
                        :max="end_date_driver_owncar"
                        @change="getRequestDriverOwnCarStatistics()"
                      />
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-6">
                      <label for="end-date"> To </label>
                      <input
                        type="date"
                        name="end-date"
                        class="date-picker"
                        v-model="end_date_driver_owncar"
                        :max="max_date"
                        :min="start_date_driver_owncar"
                        @change="getRequestDriverOwnCarStatistics()"
                      />
                    </div>
                  </v-col>
                </v-row>
              </div>
              <div class="card-content">
                <v-row
                  class="item"
                  v-for="item in lst_driver_owncar"
                  :key="item.type"
                >
                  <label class="request-name"> {{ item.type }} </label>
                  <progress
                    class="progress"
                    :value="item.number"
                    :max="total_driver_owncar"
                  ></progress>
                  <label class="quantity"> {{ item.number }} </label>
                  <label>
                    ({{
                      total_driver_owncar != 0
                        ? Math.round(
                            (item.number * 100) / total_driver_owncar
                          )
                        : 0
                    }}%)
                  </label>
                </v-row>
              </div>
            </div>
          </div>
        </div>

          <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="card">
            <div class="card-body">
              <div class="card-title">
                <v-row>
                  <v-col cols="3" class="title"> Current Driver</v-col>
                  <v-col cols="9" class="row" style="text-align: right">
                    <div class="col-md-12 col-lg-6">
                      <label for="start-date"> From </label>
                      <input
                        type="date"
                        name="start-date"
                        class="date-picker"
                        v-model="start_date_driver_current_driver"
                        :max="end_date_driver_current_driver"
                        @change="getRequestDriverCurrentDriverStatistics()"
                      />
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-6">
                      <label for="end-date"> To </label>
                      <input
                        type="date"
                        name="end-date"
                        class="date-picker"
                        v-model="end_date_driver_current_driver"
                        :max="max_date"
                        :min="start_date_driver_current_driver"
                        @change="getRequestDriverCurrentDriverStatistics()"
                      />
                    </div>
                  </v-col>
                </v-row>
              </div>
              <div class="card-content">
                <v-row
                  class="item"
                  v-for="item in lst_driver_current_driver"
                  :key="item.type"
                >
                  <label class="request-name"> {{ item.type }} </label>
                  <progress
                    class="progress"
                    :value="item.number"
                    :max="total_driver_current_driver"
                  ></progress>
                  <label class="quantity"> {{ item.number }} </label>
                  <label>
                    ({{
                      total_driver_current_driver != 0
                        ? Math.round(
                            (item.number * 100) / total_driver_current_driver
                          )
                        : 0
                    }}%)
                  </label>
                </v-row>
              </div>
            </div>
          </div>
        </div>

          <div class="col-lg-6 col-md-6 col-sm-12">
          <div class="card">
            <div class="card-body">
              <div class="card-title">
                <v-row>
                  <v-col cols="3" class="title">Is OT</v-col>
                  <v-col cols="9" class="row" style="text-align: right">
                    <div class="col-md-12 col-lg-6">
                      <label for="start-date"> From </label>
                      <input
                        type="date"
                        name="start-date"
                        class="date-picker"
                        v-model="start_date_driver_is_ot"
                        :max="end_date_driver_is_ot"
                        @change="getRequestDriverIsOTStatistics()"
                      />
                    </div>
                    <div class="col-sm-12 col-md-12 col-lg-6">
                      <label for="end-date"> To </label>
                      <input
                        type="date"
                        name="end-date"
                        class="date-picker"
                        v-model="end_date_driver_is_ot"
                        :max="max_date"
                        :min="start_date_driver_is_ot"
                        @change="getRequestDriverIsOTStatistics()"
                      />
                    </div>
                  </v-col>
                </v-row>
              </div>
              <div class="card-content">
                <v-row
                  class="item"
                  v-for="item in lst_driver_is_ot"
                  :key="item.type"
                >
                  <label class="request-name"> {{ item.type }} </label>
                  <progress
                    class="progress"
                    :value="item.number"
                    :max="total_driver_is_ot"
                  ></progress>
                  <label class="quantity"> {{ item.number }} </label>
                  <label>
                    ({{
                      total_driver_is_ot != 0
                        ? Math.round(
                            (item.number * 100) / total_driver_is_ot
                          )
                        : 0
                    }}%)
                  </label>
                </v-row>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { authHeader } from "../../../_helpers";
export default {
  data: () => ({
    lst_job_request: null,
    lst_work_schedule: null,
    lst_work_national: null,
    lst_work_day: null,
    lst_work_cooking: null,
    lst_work_kid: null,
    lst_work_pet: null,
    lst_work_current_helper: null,
    lst_work_language: null,
    lst_driver_language: null,
    lst_driver_age: null,
    lst_driver_schedule: null,
    lst_driver_salary: null,
    lst_driver_hiring: null,
    lst_driver_owncar: null,
    lst_driver_current_driver: null,
    lst_driver_is_ot: null,
    lst_driver_interview: null,
    lst_driver_replacement_gurantee: null,

    max_date: new Date().toISOString().slice(0, 10),

    start_date_job: new Date().toISOString().slice(0, 10),
    end_date_job: new Date().toISOString().slice(0, 10),
    start_date_work_schedule: new Date().toISOString().slice(0, 10),
    end_date_work_schedule: new Date().toISOString().slice(0, 10),
    start_date_work_cooking: new Date().toISOString().slice(0, 10),
    end_date_work_cooking: new Date().toISOString().slice(0, 10),
    start_date_work_kid: new Date().toISOString().slice(0, 10),
    end_date_work_kid: new Date().toISOString().slice(0, 10),
    start_date_work_pet: new Date().toISOString().slice(0, 10),
    end_date_work_pet: new Date().toISOString().slice(0, 10),
    start_date_work_current_helper: new Date().toISOString().slice(0, 10),
    end_date_work_current_helper: new Date().toISOString().slice(0, 10),
    start_date_work_national: new Date().toISOString().slice(0, 10),
    end_date_work_national: new Date().toISOString().slice(0, 10),
    start_date_work_day: new Date().toISOString().slice(0, 10),
    end_date_work_day: new Date().toISOString().slice(0, 10),
    start_date_work_language: new Date().toISOString().slice(0, 10),
    end_date_work_language: new Date().toISOString().slice(0, 10),
    start_date_driver_language: new Date().toISOString().slice(0, 10),
    end_date_driver_language: new Date().toISOString().slice(0, 10),

    start_date_driver_owncar: new Date().toISOString().slice(0, 10),
    end_date_driver_owncar: new Date().toISOString().slice(0, 10),
     start_date_driver_current_driver: new Date().toISOString().slice(0, 10),
    end_date_driver_current_driver: new Date().toISOString().slice(0, 10),
     start_date_driver_is_ot: new Date().toISOString().slice(0, 10),
    end_date_driver_is_ot: new Date().toISOString().slice(0, 10),

    start_date_driver_age: new Date().toISOString().slice(0, 10),
    end_date_driver_age: new Date().toISOString().slice(0, 10),
    start_date_driver_schedule: new Date().toISOString().slice(0, 10),
    end_date_driver_schedule: new Date().toISOString().slice(0, 10),
    start_date_driver_salary: new Date().toISOString().slice(0, 10),
    end_date_driver_salary: new Date().toISOString().slice(0, 10),
    start_date_driver_hiring: new Date().toISOString().slice(0, 10),
    end_date_driver_hiring: new Date().toISOString().slice(0, 10),
    start_date_driver_interview: new Date().toISOString().slice(0, 10),
    end_date_driver_interview: new Date().toISOString().slice(0, 10),
    start_date_driver_replacement_gurantee: new Date().toISOString().slice(0, 10),
    end_date_driver_replacement_gurantee: new Date().toISOString().slice(0, 10),
  }),
  methods: {
    async getRequestJobStatistics() {
      this.total_job = 0;
      const { data } = await this.$http.get(
        `/back-office/request-statistics?start_date=${this.start_date_job}&end_date=${this.end_date_job}`,
        authHeader()
      );
      this.lst_job_request = data;
      this.lst_job_request.forEach((element) => {
        this.total_job += element.number;
      });
      console.log(this.total_job);
    },
    async getRequestScheduleStatistics() {
      this.total_schedule = 0;
      const { data } = await this.$http.get(
        `/back-office/request-schedule-statistics?start_date=${this.start_date_work_schedule}&end_date=${this.end_date_work_schedule}`,
        authHeader()
      );
      this.lst_work_schedule = data;
      this.lst_work_schedule.forEach((element) => {
        this.total_schedule += element.number;
      });
    },
    async getRequestNationalStatistics() {
      this.total_national = 0;
      const { data } = await this.$http.get(
        `/back-office/request-national-statistics?start_date=${this.start_date_work_national}&end_date=${this.end_date_work_national}`,
        authHeader()
      );
      this.lst_work_national = data;
      this.lst_work_national.forEach((element) => {
        this.total_national += element.number;
      });
    },
    async getRequestDayStatistics() {
      this.total_day = 0;
      const { data } = await this.$http.get(
        `/back-office/request-day-statistics?start_date=${this.start_date_work_day}&end_date=${this.end_date_work_day}`,
        authHeader()
      );
      this.lst_work_day = data;
      this.lst_work_day.forEach((element) => {
        this.total_day += element.number;
      });
    },
    async getRequestLanguageStatistics() {
      this.total_language = 0;
      const { data } = await this.$http.get(
        `/back-office/request-language-statistics?start_date=${this.start_date_work_language}&end_date=${this.end_date_work_language}`,
        authHeader()
      );
      this.lst_work_language = data;
      this.lst_work_language.forEach((element) => {
        this.total_language += element.number;
      });
    },
    async getRequestDriverLanguageStatistics() {
      this.total_driver_language = 0;
      const { data } = await this.$http.get(
        `/back-office/request-driver-language-statistics?start_date=${this.start_date_driver_language}&end_date=${this.end_date_driver_language}`,
        authHeader()
      );
      this.lst_driver_language = data;
      console.log(this.lst_driver_language);
      this.lst_driver_language.forEach((element) => {
        this.total_driver_language += element.number;
      });
    },
    async getRequestDriverAgeStatistics() {
      this.total_driver_age = 0;
      const { data } = await this.$http.get(
        `/back-office/request-driver-age-statistics?start_date=${this.start_date_driver_age}&end_date=${this.end_date_driver_age}`,
        authHeader()
      );
      this.lst_driver_age = data;
      this.lst_driver_age.forEach((element) => {
        this.total_driver_age += element.number;
      });
    },
    async getRequestDriverScheduleStatistics() {
      this.total_driver_schedule = 0;
      const { data } = await this.$http.get(
        `/back-office/request-driver-schedule-statistics?start_date=${this.start_date_driver_schedule}&end_date=${this.end_date_driver_schedule}`,
        authHeader()
      );
      this.lst_driver_schedule = data;
      this.lst_driver_schedule.forEach((element) => {
        this.total_driver_schedule += element.number;
      });
    },
    async getRequestDriverSalaryStatistics() {
      this.total_driver_salary = 0;
      const { data } = await this.$http.get(
        `/back-office/request-driver-salary-statistics?start_date=${this.start_date_driver_salary}&end_date=${this.end_date_driver_salary}`,
        authHeader()
      );
      this.lst_driver_salary = data;
      this.lst_driver_salary.forEach((element) => {
        this.total_driver_salary += element.number;
      });
    },
    async getRequestDriverHiringStatistics() {
      this.total_driver_hiring = 0;
      const { data } = await this.$http.get(
        `/back-office/request-driver-hiring-statistics?start_date=${this.start_date_driver_hiring}&end_date=${this.end_date_driver_hiring}`,
        authHeader()
      );
      this.lst_driver_hiring = data;
      this.lst_driver_hiring.forEach((element) => {
        this.total_driver_hiring += element.number;
      });
    },
    async getRequestDriverInterviewStatistics() {
      this.total_driver_interview = 0;
      const { data } = await this.$http.get(
        `/back-office/request-driver-interview-statistics?start_date=${this.start_date_driver_interview}&end_date=${this.end_date_driver_interview}`,
        authHeader()
      );
      this.lst_driver_interview = data;
      this.lst_driver_interview.forEach((element) => {
        this.total_driver_interview += element.number;
      });
    },
    async getRequestDriverReplacementGuranteeStatistics() {
      this.total_driver_replacement_gurantee = 0;
      const { data } = await this.$http.get(
        `/back-office/request-driver-replacement-gurantee-statistics?start_date=${this.start_date_driver_replacement_gurantee}&end_date=${this.end_date_driver_replacement_gurantee}`,
        authHeader()
      );
      this.lst_driver_replacement_gurantee = data;
      this.lst_driver_replacement_gurantee.forEach((element) => {
        this.total_driver_replacement_gurantee += element.number;
      });
    },

    async getRequestCookingStatistics() {
      this.total_cooking = 0;
      const { data } = await this.$http.get(
        `/back-office/request-cooking-statistics?start_date=${this.start_date_work_cooking}&end_date=${this.end_date_work_cooking}`,
        authHeader()
      );
      this.lst_work_cooking = data;
      this.lst_work_cooking.forEach((element) => {
        this.total_cooking += element.number;
      });
    },
    async getRequestKidStatistics() {
       this.total_kid = 0;
      const { data } = await this.$http.get(
        `/back-office/request-kid-statistics?start_date=${this.start_date_work_kid}&end_date=${this.end_date_work_kid}`,
        authHeader()
      );
      this.lst_work_kid = data;
      this.lst_work_kid.forEach((element) => {
        this.total_kid += element.number;
      });
    },
    async getRequestPetStatistics() {
       this.total_pet = 0;
      const { data } = await this.$http.get(
        `/back-office/request-pet-statistics?start_date=${this.start_date_work_pet}&end_date=${this.end_date_work_pet}`,
        authHeader()
      );
      this.lst_work_pet = data;
      this.lst_work_pet.forEach((element) => {
        this.total_pet += element.number;
      });
    },
    async getRequestCurrentHelperStatistics() {
     this.total_current_helper = 0;
      const { data } = await this.$http.get(
        `/back-office/request-current-helper-statistics?start_date=${this.start_date_work_current_helper}&end_date=${this.end_date_work_current_helper}`,
        authHeader()
      );
      this.lst_work_current_helper = data;
      this.lst_work_current_helper.forEach((element) => {
        this.total_current_helper += element.number;
      });
    },
    async getRequestDriverOwnCarStatistics() {
      this.total_driver_owncar = 0;
      const { data } = await this.$http.get(
        `/back-office/request-driver-owncar-statistics?start_date=${this.start_date_driver_owncar}&end_date=${this.end_date_driver_owncar}`,
        authHeader()
      );
      this.lst_driver_owncar = data;
      this.lst_driver_owncar.forEach((element) => {
        this.total_driver_owncar += element.number;
      });
    },
    async getRequestDriverCurrentDriverStatistics() {
      this.total_driver_current_driver = 0;
      const { data } = await this.$http.get(
        `/back-office/request-driver-current-driver-statistics?start_date=${this.start_date_driver_current_driver}&end_date=${this.end_date_driver_current_driver}`,
        authHeader()
      );
      this.lst_driver_current_driver = data;
      this.lst_driver_current_driver.forEach((element) => {
        this.total_driver_current_driver += element.number;
      });
    },
    async getRequestDriverIsOTStatistics() {
      this.total_driver_is_ot = 0;
      const { data } = await this.$http.get(
        `/back-office/request-driver-is-ot-statistics?start_date=${this.start_date_driver_is_ot}&end_date=${this.end_date_driver_is_ot}`,
        authHeader()
      );
      this.lst_driver_is_ot = data;
      this.lst_driver_is_ot.forEach((element) => {
        this.total_driver_is_ot += element.number;
      });
    },
  },
  created() {
    this.getRequestCookingStatistics();
    this.getRequestKidStatistics();
    this.getRequestPetStatistics();
    this.getRequestCurrentHelperStatistics();
    this.getRequestDriverOwnCarStatistics();
    this.getRequestDriverCurrentDriverStatistics();
    this.getRequestDriverIsOTStatistics();
    this.getRequestNationalStatistics();
    this.getRequestDayStatistics();
    this.getRequestJobStatistics();
    this.getRequestScheduleStatistics();
    this.getRequestLanguageStatistics();
    this.getRequestDriverLanguageStatistics();
    this.getRequestDriverAgeStatistics();
    this.getRequestDriverScheduleStatistics();
    this.getRequestDriverSalaryStatistics();
    this.getRequestDriverHiringStatistics();
    this.getRequestDriverInterviewStatistics();
    this.getRequestDriverReplacementGuranteeStatistics();
  },
};
</script>

<style scoped>
.overview {
  margin: 0 auto;
}
h4 {
  text-decoration: underline;
}
.card {
  text-align: center;
  margin: 1rem auto;
  border: #00000059 1px solid;
}
.date-picker {
  border: black 1px solid;
  border-radius: 5%;
}
.card-title {
  border-bottom: #00000059 1px solid;
}
.card-content {
  margin: 2rem;
}
.request-name {
  text-align: left;
  width: 23%;
}
.progress {
  width: 55%;
}
.item {
  align-items: center;
}
.quantity {
  margin-left: 1rem;
  margin-right: 0.25rem;
}
.title {
  text-decoration: bold;
  font-size: 1.5rem;
}
.card {
  border-radius: 3%;
}
</style>